import Sections from "components/Contractors/sections";
import {ReadOnlyTextField} from "components/Shared/ReadOnlyTextField";
import {ContractorRolesReadonlyCheckboxGroup} from "./ContractorRolesReadonlyCheckboxGroup";
import {DetailsColumn} from "components/Shared/CrudComponents";
import React from "react";
import { CONTRACTOR_ROLES_READ, useAuth } from 'context/auth'

export const ContractorBasicDetails = ({contractor, previousContractor, ...columnProps}) => {
  const { hasAnyPrivileges } = useAuth()

  return (
    <DetailsColumn section={Sections.BasicDetails} {...columnProps}>
      <ReadOnlyTextField label={'contractor.form.fullName'} value={contractor.fullName}
                         previousValue={previousContractor && { value: previousContractor.fullName }}/>
      <ReadOnlyTextField label={'contractor.form.shortName'} value={contractor.shortName}
                         previousValue={previousContractor && { value: previousContractor.shortName }}/>
      <ReadOnlyTextField label={'contractor.form.nipNumber'} value={contractor.nipNumber}
                         previousValue={previousContractor && { value: previousContractor.nipNumber }}/>
      <ReadOnlyTextField label={'contractor.form.regonNumber'} value={contractor.regonNumber}
                         previousValue={previousContractor && { value: previousContractor.regonNumber }}/>
      <ReadOnlyTextField label={'contractor.form.krsNumber'} value={contractor.krsNumber}
                         previousValue={previousContractor && { value: previousContractor.krsNumber }}/>
      <ReadOnlyTextField label={'contractor.form.phoneNumber'} value={contractor.phoneNumber}
                         previousValue={previousContractor && { value: previousContractor.phoneNumber }}/>
      <ReadOnlyTextField label={'contractor.form.contactEmail'} value={contractor.contactEmail}
                         previousValue={previousContractor && { value: previousContractor.contactEmail }}/>
      <ReadOnlyTextField label={'contractor.form.accountingEmail'} value={contractor.accountingEmail}
                         previousValue={previousContractor && { value: previousContractor.accountingEmail }}/>
      {hasAnyPrivileges([CONTRACTOR_ROLES_READ]) &&
        <ContractorRolesReadonlyCheckboxGroup roles={contractor.roles} previousRoles={previousContractor?.roles}/>
      }
    </DetailsColumn>
  )
}